import React from 'react';
import { Box, CardMedia, Stack, Typography } from '@mui/material';
import InspectionYoutube from './Youtube/InspectionYoutube';
import FocusInspectionButtonWeb from './FocusInspectionButtonWeb';

const InspectCarBannerWeb = () => (
  <>
    <Stack direction="row" pr="75px" pl="90px" pt="180px" pb={15}>
      <Stack
        sx={{
          width: '100%',
          color: '#fff',
          justifyContent: 'center',
          fontFamily: "'Segoe UI', sans-serif",
        }}
      >
        <Stack mb={8}>
          {/* Focus */}
          <Typography
            variant="subtitle2"
            sx={{
              background: 'linear-gradient(to right, #EA5D16, #F6851F)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              textTransform: 'uppercase',
              fontWeight: 600,
              fontSize: 20,
              letterSpacing: 1,
            }}
          >
            Focus
          </Typography>

          {/* Badge + Inspect text wrapper */}
          <Box sx={{ position: 'relative', mt: 1, ml: 2.1, width: 'fit-content' }}>
            {/* Emblem Label Badge */}
            <Box
              sx={{
                // backgroundColor: '#D9D9D9',
                color: '#000',
                borderRadius: '50%',
                width: 104,
                height: 68,
                position: 'absolute',
                top: '-40px',
                right: '-66px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                // p: 2.5,
                transform: 'rotate(-3deg)',
              }}
            >
              <CardMedia
                component="img"
                className=""
                src="assets/images/Inspection/seal.png"
                alt="Card Image"
                // height={isMobile ? 25 : 40}
                sx={{ objectFit: 'contain', borderRadius: '10px' }}
              />
            </Box>

            {/* Inspect any car */}
            <Typography
              sx={{
                fontWeight: 600,
                color: '#FFFEFD',
                lineHeight: 1,
                fontSize: 70,
              }}
            >
              Inspect <br /> any car
            </Typography>
          </Box>

          {/* you’re going to buy! */}
          <Typography
            variant="subtitle1"
            sx={{
              background: 'linear-gradient(to right, #EA5D16, #F6851F)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontSize: 40,
              fontWeight: 600,
            }}
          >
            you’re going to buy!
          </Typography>
        </Stack>

        <FocusInspectionButtonWeb
          title="Book FOCUS Certified Inspection!"
          subtitle="Inspection team will contact you soon."
          onClick={() => console.log('Button clicked')}
        />
      </Stack>
      <Stack
        sx={{
          width: '100%',
          justifyContent: 'center',
        }}
      >
        <Box sx={{}}>
          <InspectionYoutube youtubeId="RGBhSS6JtGQ" />
        </Box>
      </Stack>
    </Stack>
  </>
);

export default InspectCarBannerWeb;
